// assets/faq-accordion.js
(function () {
  function initAccordions(scope) {
    var acc = (scope || document).getElementsByClassName('accordion');
    for (var i = 0; i < acc.length; i++) {
      // avoid double-binding
      if (acc[i].dataset.accordionBound === '1') continue;
      acc[i].dataset.accordionBound = '1';

      acc[i].addEventListener('click', function () {
        this.classList.toggle('active');
        var panel = this.nextElementSibling;
        if (!panel) return;
        if (panel.style.maxHeight) {
          panel.style.maxHeight = null;
        } else {
          panel.style.maxHeight = panel.scrollHeight + 'px';
        }
      });
    }
  }

  // Run on initial load
  document.addEventListener('DOMContentLoaded', function () {
    initAccordions(document);
  });

  // If your theme swaps sections dynamically, re-init when sections load
  document.addEventListener('shopify:section:load', function (e) {
    initAccordions(e.target);
  });
})();
